import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AssetService } from '../../services/asset-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { GeoArea } from 'src/app/assabil-kernel/models/entities/control-tables/geo-area-entity';



@Component({
  selector: 'geo-area-kpis-widget',
  templateUrl: './geo-area-kpis-widget.component.html',
  styleUrls: ['./geo-area-kpis-widget.component.scss']
})


export class GeoAreaKpisWidgetComponent implements OnInit {
  
  @Input() geoArea           : GeoArea;
  @Input() openedGeoAreas    : GeoArea[];


  @Output() onShowMap = new EventEmitter<any>();

  ngOnInit(){}

  constructor( 
    protected leanUtilsService    : LeanUtilsService,
    protected assetService        : AssetService
   ) {
  }



  showMap(roleCode : string){
    this.onShowMap.emit(roleCode);
  }


  click(){
    this.geoArea.expanded = ! this.geoArea.expanded;
    }

}


